<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="icon-wrapper">
    <div :class="size + '-' + typeLowercase + (filled ? '-filled' : '') + '-icon'" />
  </div>
</template>

<script>
/**
 * Display diferent icon logo depending on type
 */
export default {
  name: 'ItemIcon',
  props: {
    /**
     * Sets the type of the icon
     * @values microdades, mapes, estadístiques, enquestes, documents, apps
     */
    type: {
      type: String,
    },
    /**
     * Sets the size of the icon
     * @values sm, md
     */
    size: {
      type: String,
    },
    /**
     * True if want to print icon filled
     */
    filled: {
      type: Boolean,
    },
  },
  computed: {
    typeLowercase() {
      return this.type.toLowerCase()
    },
  },
}
</script>

<style lang="stylus" scoped>
.icon-wrapper
  $icons = "statistics" "microdata" "survey" "docs" "maps" "datastories" "comunication"
  $sizes = "xxsm" "xsm" "sm" "md"

  for $size in $sizes
    for $icon in $icons
      .{$size}-{$icon}-icon
        if ($size == "xxsm")
          m-icon("f-" + $icon, 18, $corporate_color)

        if ($size == "xsm")
          m-icon("f-" + $icon, 24, $corporate_color)

        if ($size == "sm")
          m-icon("f-" + $icon, 28, $corporate_color)

        if ($size == "md")
          m-icon("f-" + $icon, 44, $corporate_color)

      .{$size}-{$icon}-filled-icon
        if ($size == "xsm")
          m-icon("f-" + $icon + "-fill", 24, $corporate_color, false)

        if ($size == "sm")
          m-icon("f-" + $icon + "-fill", 28, $corporate_color, false)

        if ($size == "md")
          m-icon("f-" + $icon + "-fill", 44, $corporate_color, false)
</style>

<docs lang="md">
Example of diferent type of items

```jsx
<div id="measure" style="display: flex; gap: 25px; justify-content: center">
  <div style="display: flex; flex-direction: column;  gap: 10px;">
    <span>Microdades</span>
    <ItemIcon type="microdades" size="sm" />
  </div>
  <div style="display: flex; flex-direction: column;  gap: 10px;">
    <span>Mapes</span>
    <ItemIcon type="mapes" size="sm" />
  </div>
  <div style="display: flex; flex-direction: column;  gap: 10px;">
    <span>Estadístiques</span>
    <ItemIcon type="estadístiques" size="sm" />
  </div>
  <div style="display: flex; flex-direction: column;  gap: 10px;">
    <span>Enquestes</span>
    <ItemIcon type="enquestes" size="sm" />
  </div>
  <div style="display: flex; flex-direction: column;  gap: 10px;">
    <span>Documents</span>
    <ItemIcon type="documents" size="sm" />
  </div>
  <div style="display: flex; flex-direction: column;  gap: 10px;">
    <span>Apps</span>
    <ItemIcon type="apps" size="sm" />
  </div>
</div>
```

</docs>